import z from 'zod';

export const PlatformTypes = z.enum(['apple', 'windows', 'android']);
